import React from "react";
import styles from "./KeyFeatures.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowTrendUp,
    faBolt,
    faChartLine, faLayerGroup, faLink,
    faMobileAlt,
    faPalette,
    faPlug,
    faSearch
} from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";
import {t} from "i18next";

const keyFeatures: React.FC = () => {
    // const { t } = useTranslation();

    const keyFeatures = [
        {
            title: `${String(t('services.webApplications.keyFeatures.keyFeature1Title'))}`,
            icon: faPlug,
            description: "Robust APIs that connect your systems, enable automation, and support seamless data flow."
        },
        {
            title: "Third-Party Integrations",
            icon: faLink,
            description: "Secure integrations with external tools and services to extend functionality and streamline operations."
        },
        {
            title: "Data Analytics & Dashboards",
            icon: faChartLine,
            description: "Clear, real-time dashboards that turn data into actionable insights for smarter decision-making."
        },
        {
            title: "Scalable Application Architecture",
            icon: faLayerGroup,
            description: "Future-ready architecture designed to grow with your business without performance bottlenecks."
        }
    ];


    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className="sectionTitle">
                    Core Web Application Capabilities
                </h1>
            </LazyText>
            {/* YOUR GRID — UNTOUCHED */}
            {/*<LazyText>*/}
            <div className={styles.gridContainer}>
                {keyFeatures.map((feature, index) => (
                    <div className={styles.card}>
                        <div className={styles.card_title}>
                            {feature.title}
                        </div>
                        <div className={styles.icon_container}>
                            <FontAwesomeIcon icon={feature.icon}/>
                        </div>
                        <div className={styles.content}>
                            <p>
                                {feature.description}
                            </p>
                        </div>
                    </div>

                ))}
            </div>
            {/*</LazyText>*/}
        </section>
    );
};

export default keyFeatures;
